export default "__VITE_ASSET__CKOvsWMI__"